<template>
  <div class="lcu-page">
    <section class="section">
      <annoucement-banner />
      <page-legend />
    </section>
    <section class="section">
      <header class="lcu-section-header">Mis Programas</header>
      <div v-if="!userLoading && !programsLoading">
        <div v-if="studentPrograms.length > 0">
          <router-link
            class="lcu-myProgram-card"
            :to="'/programas/registrada/' + program.slug"
            :key="program.slug"
            v-for="program in studentPrograms">
            <img class="lcu-myProgram-logo" :src="program.image" alt="lcu-program-logo" />
            <span class="lcu-myProgram-name"> {{ program.degree + ' en ' + program.name }} </span>
            <span
              class="lcu-myProgram-progress"
              :class="{
                'lcu-progress-green': program.completed,
                'lcu-progress-orange': program.sections > 0 && !program.completed,
                'lcu-progress-blue': program.sections === 0,
              }">
              <span v-if="program.sections > 0 && !program.completed">
                En progreso
              </span>
              <span v-if="program.completed">
                Completado
              </span>
              <span v-if="program.sections === 0">
                No iniciado
              </span>
            </span>
          </router-link>
        </div>
        <div class="lcu-no-programs" v-else>
          <span class="lcu-program-icon" />
          No estás registrado en ningún programa
        </div>
      </div>
      <div class="row row-center" v-if="userLoading || programsLoading">
        <spin-loader :size="'100px'" />
      </div>
    </section>
    <section class="section">
      <header class="lcu-section-header">Programas Disponibles</header>
      <div class="col-grid-3" v-if="!programsLoading">
        <ProgressCard
          v-for="(card, index) in programs"
          :card="card"
          :bgSize="'contain'"
          :key="index" />
      </div>
      <div class="row row-center" v-if="programsLoading">
        <spin-loader :size="'100px'" />
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import PageLegend from 'ç/page-legend/PageLegend.vue';
import ProgressCard from 'ç/progress-card/ProgressCard.vue';
import Announement from 'ç/announcement/Announcement.vue';
import SpinLoader from 'ç/loaders/spin/Spin.vue';

export default {
  name: 'programs-page',
  computed: {
    ...mapGetters(['user', 'userLoading']),
  },
  components: {
    'annoucement-banner': Announement,
    PageLegend,
    ProgressCard,
    SpinLoader,
  },
  data() {
    return {
      programsLoading: false,
      internval: null,
      currentTime: null,
      timeFormat: 'dddd MMM Do YYYY, h:mm:ss a',
      loginModal: false,
      programs: [],
      programMap: {},
      studentPrograms: [],
    };
  },
  created() {
    this.getPrograms();
  },
  methods: {
    async getPrograms() {
      this.programsLoading = true;
      try {
        const { programs } = await this.$students({
          method: 'getAllPrograms',
          payload: {},
        });
        programs.forEach((program) => {
          this.programMap[program.slug] = program;
          const userProgram = this.user.programs[program.slug] || {};
          const progress = (p) => {
            if (p.completed) {
              return 'completed';
            }
            if (typeof p.completed !== 'undefined' && !p.completed) {
              return 'inProgress';
            }
            return false;
          };
          this.programs.push({
            image: program.image,
            header: program.name,
            subHeader: program.degree,
            progress: progress(userProgram),
            link: `/programas/${program.slug}`,
            icon: false,
          });
        });
        this.$log.info('programs: ', programs);
        _.forOwn(this.user.programs, (value, slug) => {
          const program = this.programMap[slug];
          this.studentPrograms.push({
            slug,
            name: program.name,
            degree: program.degree,
            image: program.image,
            completed: value.completed,
            sections: Object.keys(program.sections).length,
          });
        });
      } catch (e) {
        this.$log.error(e.message || e);
      } finally {
        this.programsLoading = false;
      }
    },
    checkLink(path) {
      if (!this.user.id) {
        this.loginModal = true;
        window.localStorage.setItem('lcuRequestedPath', path);
      } else {
        this.$router.push({ path });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-myProgram-card {
  display: grid;
  grid-template-columns: max-content 1fr max-content;
  background-color: $white;
  border: 1px solid $page-border;
  border-radius: 5px;
  padding: 10px 20px;
  grid-gap: 50px;
  align-items: center;
  color: $legacy-primary;
  text-decoration: none;
  transition: background-color .2s;

  &:hover {
    background-color: $off-white;
  }

  @media only screen and (max-width: $mobile-max) {
    grid-template-columns: 1fr;
    grid-gap: 0;
  }
}

.lcu-myProgram-logo {
  width: 50px;

  @media only screen and (max-width: $mobile-max) {
    margin-bottom: 25px;
  }
}

.lcu-myProgram-name {
  font-weight: bold;
  @media only screen and (max-width: $mobile-max) {
    margin-bottom: 10px;
  }
}

.lcu-myProgram-progress {
  text-transform: capitalize;

  &:before {
    font-size: 24px;
    display: inline-block;
    position: relative;
    top: 3px;
    content: '\2022';
    margin: 0;
  }

  @media only screen and (max-width: $mobile-max) {
    &:before {
      width: 0px;
      line-height: 0;
      margin-right: 15px;
    }
  }
}

.lcu-progress-blue {
  &:before {
    color: $progress-blue;
  }
}

.lcu-progress-orange {
  &:before {
    color: $progress-orange;
  }
}

.lcu-progress-green {
  &:before {
    color: $progress-green;
  }
}

.lcu-progress-circle {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  margin-right: 10px;
  display: inline-block;
}

.lcu-arrow-btn {
  &:after {
    display: inline-block;
    font-family: 'lcu';
    content: '\e80a';
    margin-left: 10px;
  }
}

.lcu-home-summary {
  display: grid;
  grid-template-columns: 45% 1fr;
  grid-gap: 40px;

  @media only screen and (max-width: $mobile-max) {
    grid-template-columns: 1fr;
    grid-gap: 10px;
  }
}

.lcu-home-video {
  @media only screen and (max-width: $mobile-max) {
    grid-area: 2 / 1 / 3 / 3;
  }
}

.lcu-home-p {
  @media only screen and (max-width: $mobile-max) {
    grid-area: 1 / 1 / 2 / 3;
  }
}

.lcu-no-programs {
  display: flex;
  align-items: center;
}

.lcu-program-icon {
  display: inline-block;
  margin-right: 5px;

  &:before {
    font-weight: 'lcu';
    content: '\e807';
    font-size: 21px;
  }
}
</style>
